import { useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useListAgtechTicketsByContract } from "@/lib/api/agtech/ticketsExpanded";

interface ContractTicketsModalProps {
  contractNbr: number | null;
  onClose: () => void;
}

export function ContractTicketsModal({ contractNbr, onClose }: ContractTicketsModalProps) {
  const result = useListAgtechTicketsByContract({
    contract_nbrs: contractNbr !== null ? [contractNbr] : [],
  });

  useEffect(() => {
    if (result.data) {
      console.log("Contract tickets result:", result.data);
    }
  }, [result.data]);

  return (
    <Dialog open={contractNbr !== null} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>Contract #{contractNbr}</DialogTitle>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}
